import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// import { AxiosError } from 'axios';
// import { showError } from '../../../../utils/Notifications';
import documentService from '../services/document.service';

const initialState = {
  status: 'idle',
  error: null as string | null,
};

export const saveDocument = createAsyncThunk(
  '/documents/saveDocument',
  async (saveRequest: FormData) => {
    return await documentService.saveDocument(saveRequest);
  }
);

// export const deleteDocument = createAsyncThunk(
//   '/documents/deleteDocument',
//   async (fileName: string, { rejectWithValue }) => {
//     try {
//       await documentService.deleteDocument(fileName);
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

const documentSlice = createSlice({
  name: 'documentSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveDocument.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveDocument.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(saveDocument.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
    // .addCase(deleteDocument.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(deleteDocument.fulfilled, (state) => {
    //   state.status = 'succeeded';
    // })
    // .addCase(deleteDocument.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.payload as string;
    //   showError(`Deleting document failed. ${action.payload as string}`);
    // });
  },
});

export default documentSlice.reducer;
